import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store";
import Login from "./pages/Login/Login";
import Signup from "./pages/Signup/Signup";
import AdminDashboard from "./pages/Admin/AdminDashboard/AdminDashboard";
import { ConfigProvider } from "antd";
import PartnerDashboard from "./pages/Partner/PartnerDashboard/PartnerDashboard";
import CustomerDashboard from "./pages/Customer/CustomerDashboard/CustomerDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import { PermissionProvider } from "./contexts/PermissionContext";
import AcceptInvitation from "./pages/AcceptInvitation/AcceptInvitation";
import PartnerInvitation from "./pages/PartnerInvitation/PartnerInvitation";
import PublicBenchShare from "./pages/PublicBenchShare/PublicBenchShare";

function App() {
  return (
    <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Quicksand",
          colorPrimary: "#014C75",
          colorLink: "#01D9A9",
        },
      }}
    >
      <BrowserRouter>
        <PermissionProvider>
          <Routes>
            {/* <Route path="*" element={<NoPage />} /> */}
            <Route path="/" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/accept-invitation" element={<AcceptInvitation />} />
            <Route path="/partner-invitation" element={<PartnerInvitation />} />
            <Route path="/bench/share/:shareSlug" element={<PublicBenchShare />} />
            {/* Admin dashboard routes */}
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/partner/*" element={<ProtectedRoute requiredRole="partner"><PartnerDashboard /></ProtectedRoute>} />
            <Route path="/customer/*" element={<ProtectedRoute requiredRole="customer"><CustomerDashboard /></ProtectedRoute>} />
            <Route path="/*" element={<Login />} />
          </Routes>
        </PermissionProvider>
      </BrowserRouter>
    </ConfigProvider>
    </Provider>
  );
}

export default App;
